import { render, staticRenderFns } from "./user-editor.vue?vue&type=template&id=0825d598&"
import script from "./user-editor.vue?vue&type=script&lang=js&"
export * from "./user-editor.vue?vue&type=script&lang=js&"
import style0 from "./user-editor.vue?vue&type=style&index=0&id=0825d598&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports